import { selectCurrentClusterId } from "@single-js/common/core/sql/selectors";
import { selectError, selectLoadingOrInitial, selectPayload, } from "@single-js/common/util/loading-state-machine";
import { decodeClusterJwt } from "data/models";
import _ from "lodash";
import { createSelector } from "reselect";
export const selectClusters = (s) => selectPayload(s.clusters.clusters);
export const selectClustersError = (s) => selectError(s.clusters.clusters);
export const selectClustersLoadingOrInitial = (s) => selectLoadingOrInitial(s.clusters.clusters);
export const selectCurrentCluster = createSelector(selectCurrentClusterId, selectClusters, (clusterId, clusters) => {
    if (clusterId) {
        // Try to parse the Cluster ID as a JWT. If it works, we're dealing
        // with a JWT connection. Otherwise, try to find the regular cluster
        // ID in the list of clusters from the API.
        const jwtCluster = decodeClusterJwt(clusterId);
        if (jwtCluster) {
            return jwtCluster;
        }
        if (clusters) {
            return _.find(clusters, (c) => c.id === clusterId);
        }
    }
    return undefined;
});
